import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'personalInformation.header',
    description: 'Header for personal information page',
    defaultMessage: 'Do Not Sell or Share My Personal Information',
  },
  contentOne: {
    id: 'personalInformation.contentOne',
    description: 'Content for personal information page paragraph one',
    defaultMessage:
      'Although we do not sell your personal information for money, our sharing of your personal information with some advertising partners may be deemed a “sale” or “sharing” for targeted advertising purposes under applicable privacy laws.',
  },
  contentTwo: {
    id: 'personalInformation.contentTwo',
    description: 'Content for personal information page paragraph two',
    defaultMessage:
      'If you would like to request an opt-out from the sale or sharing of your personal information that does not take place via cookies or similar technologies on this website, you may do so by providing the email address associated with your Starbucks Rewards account or activity on Starbucks sites below, which will help us match the request to your account. This choice does not impact your Starbucks Rewards account, app experience, or Starbucks emails and can be managed any time in your account settings.',
  },
  contentThree: {
    id: 'personalInformation.contentThree',
    description: 'Content for personal information page paragraph three',
    defaultMessage:
      'You may opt out of the sale or sharing of personal information that takes place via cookies and similar technologies on this website by managing your preferences using the Cookie Preferences link at the bottom of this website. Please see our { privacyNotice } for more details.',
  },
  manageCookiePreferences: {
    id: 'personalInformation.manageCookiePreferences',
    description: 'Manage cookie preferences button',
    defaultMessage: 'Manage cookie preferences',
  },
  confirmationHeader: {
    id: 'personalInformation.confirmationHeader.header',
    description: 'Header for personal information confirmation page',
    defaultMessage: 'We got your submission',
  },
  confirmationContent: {
    id: 'personalInformation.confirmationContent.content',
    description: 'Content for personal information confirmation page',
    defaultMessage:
      'If this email is in our system, we’ve noted your preferences. You can close or navigate away from this page whenever you’re ready.',
  },
});
